import { useMemo } from 'react';
import { buildOffers, type Offer } from '../../lib/offers';
import { useCartStore } from '../../store/useCartStore';
import { useProductStore } from '../../store/useProductStore';
import { useStoreInfo } from '../../store/useStoreInfo';

interface UseOffersOptions {
  /** كوبون منح توصيلاً مجانياً (من صفحة الدفع) */
  couponFreeShipping?: boolean;
}

/**
 * العروض المعروضة للعميل، مشتقة من إعدادات المتجر وأسعار المنتجات وقيمة السلة.
 * كل بطاقة مشروطة ببيانات حقيقية: التوصيل المجاني من إعدادات التطبيق،
 * وخصومات المتجر من فرق السعر الأصلي عن سعر البيع.
 */
export function useOffers(options: UseOffersOptions = {}): {
  offers: Offer[];
  isLoading: boolean;
} {
  const storeData = useStoreInfo((state) => state.data);
  const products = useProductStore((state) => state.products);
  const cartTotal = useCartStore((state) => state.total);

  const { couponFreeShipping } = options;

  const offers = useMemo(
    () =>
      buildOffers({
        storeReady: storeData != null,
        shipping: storeData?.shipping,
        freeShippingActive: storeData?.freeShippingActive,
        freeShippingThreshold: storeData?.freeShippingThreshold,
        cartTotal,
        couponFreeShipping,
        products,
      }),
    [storeData, products, cartTotal, couponFreeShipping]
  );

  return { offers, isLoading: storeData == null };
}

export default useOffers;
